import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Badge from '@ecp/common/src/components/badge/mo/Badge';
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import { SITE_SKYPASS, SITE_KOREANAIR_SAVINGS } from '@ecp/common/src/const/site/siteNumberConst.js';

import { withCartBadgeCount } from '@mo-recoil/order/selector';
import { useSiteComponentResolver } from '@mo-hooks/resolver/SiteComponentResolverHook';
import { ReactComponent as CartIcon } from '@mo-assets/icon/icon__cart.svg';
import { ReactComponent as SkypassCartIcon } from '@mo-assets/icon/skypass/icon_cart.svg';
import { ReactComponent as KoreanAirSavingsCartIcon } from '@mo-assets/icon/KoreanAirSavings/icon_cart.svg';

import { userInfoState } from '@mo-recoil/common/user/atom';
import { useConfirmDialog } from '@mo-hooks/common/useModal';
import  useLoginForward  from '@ecp/common/src/hooks/useLoginForward';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
const Wrapper = styled.div`
  width: 20px;
  height: 20px;
`;

const Cart = () => {
  const navigate = useNavigate();
  const cartBadgeCount = useRecoilValue(withCartBadgeCount);
  const { login} = useRecoilValue(userInfoState);
  const { siteNumber} = useSiteInfo();
  const { showConfirmDialog } = useConfirmDialog();
  const loginForward = useLoginForward(siteNumber, showConfirmDialog);
  const handleClick = (e) => {
    e.stopPropagation();
    if(!login) {
      loginForward();
    } else{
      navigate('/cart');
    }
  };

  const ResolvedEventMallGnb = useSiteComponentResolver(<CartIcon width={20} height={20} />, {
    // 대한항공
    [SITE_SKYPASS]: <SkypassCartIcon width={24} height={21} />,
    // 적립몰
    // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
    [SITE_KOREANAIR_SAVINGS]: <KoreanAirSavingsCartIcon width={24} height={21} />,
  });

  return (
    <Wrapper data-ds-label2={'g_basket'}>
      <Badge
        showZero
        badgeContent={cartBadgeCount}
        max={99}
        position={{
          right: -7,
          top: 0,
        }}
        size={{
          height: '16px',
          width: '16px',
        }}
        onClick={handleClick}
        // rootComponent={BadgeRootATag}
        // rootProps={{ href: '/cart', 'aria-label': `장바구니 상품 ${cartBadgeCount}개` }}
      >
        <button type="button" aria-label="장바구니 이동">
          {ResolvedEventMallGnb}
        </button>
      </Badge>
    </Wrapper>
  );
};

Cart.propTypes = {
  count: PropTypes.number,
};

export default Cart;

// const BadgeRootATag = styled.a`
//   position: relative;
//   width: 100%;
//   height: 100%;
//   margin: 0;
//   padding: 0;
// `;

